<template>
<div>
    <TableActionHeader @filterChange="onFilterChange" @newItem="onNewItem"></TableActionHeader> 
    <b-table 
        striped 
        hover 
        selectable 
        select-mode="single" 
        @row-selected="onRowSelected" 
        :items="items" 
        :fields="fields" 
        :filter="filter"
        @filtered="onFiltered"
        :per-page="perPage"
        :current-page="currentPage">
    </b-table>

    <TablePagination 
        :total-rows="totalRows" 
        :per-page="perPage" 
        @pageChange="onPageChange">
    </TablePagination>
</div>
</template>

<script>

import channel from '@/store/content/channel.js'

export default {
    data() {
        return {
            perPage: 10,
            currentPage: 1,
            fields: [
                { key: "name", label: this.$t('channel.name') },
                { key: "media", label: this.$t('channel.media') }
            ],
            filter: "",
            filteredRows: 0
        }
    },
    created() {
        if (!this.$store.state.media ) this.$store.registerModule("channel" , channel)
        this.$store.dispatch('channel/list')
    },
    computed: {
        items() {
            return this.$store.state.channel.list;
        },   
        totalRows() {
            return this.filter ?  this.filteredRows : this.items.length;
        }
    },
    methods: {
        onFilterChange(filter) {
            this.filter = filter;
        },
        onNewItem() {
            this.$emit('newItem');
        },
        onRowSelected(items) {
            this.$emit('selectItem' , items[0] );
        },
        onFiltered(filteredItems) {
            this.filteredRows = filteredItems.length;
            this.currentPage = 1;
        },
        onPageChange(selectedPage) {
            this.currentPage = selectedPage;
        }
    }
}

</script>